import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const ArrowRight = createSvgIcon(React.createElement("polygon", { points: "13.3,3.5 11.9,4.9 18,11 3,11 3,13 18,13 11.9,19.1 13.3,20.5 21.8,12 " }), 'ArrowRight');
export default ArrowRight;
